// import { Editor } from '@tiptap/core'
import React, { useEffect, useState, useRef } from 'react'
import { useEditorState } from '@tiptap/react'
import InsertLinkInput from './InsertLinkInput.jsx';


/**
 * State selector for the MenuBar component.
 * Extracts the relevant editor state for rendering menu buttons.
 */
export function menuBarStateSelector(ctx) {
    return {
        // Text formatting
        isBold: ctx.editor.isActive('bold') ?? false,
        canBold: ctx.editor.can().chain().toggleBold().run() ?? false,
        isItalic: ctx.editor.isActive('italic') ?? false,
        canItalic: ctx.editor.can().chain().toggleItalic().run() ?? false,
        isStrike: ctx.editor.isActive('strike') ?? false,
        canStrike: ctx.editor.can().chain().toggleStrike().run() ?? false,
        isUnderline: ctx.editor.isActive('underline') ?? false,
        canUnderline: ctx.editor.can().chain().toggleUnderline().run() ?? false,
        canClearMarks: ctx.editor.can().chain().unsetAllMarks().run() ?? false,

        isAlignedLeft: ctx.editor.isActive({ textAlign: 'left' }) ?? false,
        isAlignedCenter: ctx.editor.isActive({ textAlign: 'center' }) ?? false,
        isAlignedRight: ctx.editor.isActive({ textAlign: 'right' }) ?? false,

        // Block types
        isParagraph: ctx.editor.isActive('paragraph') ?? false,
        isHeading1: ctx.editor.isActive('heading', { level: 1 }) ?? false,
        isHeading2: ctx.editor.isActive('heading', { level: 2 }) ?? false,
        isHeading3: ctx.editor.isActive('heading', { level: 3 }) ?? false,
        // isHeading4: ctx.editor.isActive('heading', { level: 4 }) ?? false,
        // isHeading5: ctx.editor.isActive('heading', { level: 5 }) ?? false,
        // isHeading6: ctx.editor.isActive('heading', { level: 6 }) ?? false,

        // Lists and blocks
        isBulletList: ctx.editor.isActive('bulletList') ?? false,
        isOrderedList: ctx.editor.isActive('orderedList') ?? false,
        // isCodeBlock: ctx.editor.isActive('codeBlock') ?? false,
        // isBlockquote: ctx.editor.isActive('blockquote') ?? false,
        isLink: ctx.editor.isActive('link') ?? false,

        // History
        canUndo: ctx.editor.can().chain().undo().run() ?? false,
        canRedo: ctx.editor.can().chain().redo().run() ?? false,
    }
}


const MenuBar = ({ editor, handleInsertImage, handleSave }) => {
    const editorState = useEditorState({
        editor,
        selector: menuBarStateSelector,
    })

    if (!editor) {
        return null;
    }
    

    return (
        <div className='fixed-menu' > 
            <div className="button-group horizontal">
                <h5>Heading</h5>
                <button
                    onClick={() => editor.chain().focus().toggleHeading({ level: 1 }).run()}
                    className={editor.isActive('heading', { level: 1 }) ? 'is-active heading1' : 'heading1'}
                >  H1
                </button>
                <button
                    onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()}
                    className={editor.isActive('heading', { level: 2 }) ? 'is-active heading2' : 'heading2'}
                >
                    H2
                </button>
                <button
                    onClick={() => editor.chain().focus().toggleHeading({ level: 3 }).run()}
                    className={editor.isActive('heading', { level: 3 }) ? 'is-active heading3' : 'heading3'}
                >
                    H3
                </button>
            </div>
            <div className="button-group">
                <h5>List</h5>
                <button
                    onClick={() => editor.chain().focus().toggleBulletList().run()}
                    className={editor.isActive('bulletList') ? 'is-active' : ''}
                >
                    &bull;
                </button>
                <button
                    onClick={() => editor.chain().focus().toggleOrderedList().run()}
                    className={editor.isActive('orderedList') ? 'is-active' : ''}
                >
                    1.
                </button>
            </div> 
            <div className="button-group horizontal">
                <h5>Text Styles</h5>
                <button
                    onClick={() => editor.chain().focus().toggleBold().run()}
                    className={editor.isActive('bold') ? 'is-active' : ''}
                    style={{ fontWeight: '800' }}
                >
                    B
                </button>
                <button
                    onClick={() => editor.chain().focus().toggleItalic().run()}
                    className={editor.isActive('italic') ? 'is-active' : ''}
                    style={{ fontStyle: 'italic' }}
                >
                    I
                </button>
                <button
                    onClick={() => editor.chain().focus().toggleStrike().run()}
                    className={editor.isActive('strike') ? 'is-active' : ''}
                    style={{ textDecoration: 'line-through' }}
                >
                    S
                </button>
                <button
                    onClick={() => editor.chain().focus().toggleUnderline().run()}
                    className={editor.isActive('underline') ? 'is-active' : ''}
                    style={{ textDecoration: 'underline' }}
                >
                    U
                </button>
            </div>
            <div className="button-group ">
                <h5>Align</h5>
                <button
                    onClick={() => editor.chain().focus().setTextAlign('left').run()}
                    className={editor.isActive({ textAlign: 'left' }) ? 'is-active' : ''}
                >
                    Left
                </button>
                <button
                    onClick={() => editor.chain().focus().setTextAlign('center').run()}
                    className={editor.isActive({ textAlign: 'center' }) ? 'is-active' : ''}
                >
                    Center
                </button>
                <button
                    onClick={() => editor.chain().focus().setTextAlign('right').run()}
                    className={editor.isActive({ textAlign: 'right' }) ? 'is-active' : ''}
                >
                    Right
                </button>
            </div>
            <div className="button-group horizontal">
                <h5>Insert</h5>
                <InsertLinkInput editor={editor} />
                <button onClick={handleInsertImage}>Image</button>
            </div>
            <div className="button-group file-actions">
                <button className="file-action" onClick={() => editor.commands.undo()} disabled={!editor.can().undo()}>Undo</button>
                <button
                    className="file-action"
                    onClick={handleSave} >Save
                </button>
            </div> 
        </div>


    );
};

export default MenuBar;